import { render, staticRenderFns } from "./header_1.vue?vue&type=template&id=87233228&scoped=true"
import script from "./header_1.vue?vue&type=script&lang=js"
export * from "./header_1.vue?vue&type=script&lang=js"
import style0 from "./header_1.vue?vue&type=style&index=0&id=87233228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87233228",
  null
  
)

export default component.exports